import { ProjectsService } from "./../services/projects/projects.service";
import { UserServiceService } from "./../services/user-service/user-service.service";
import { environment } from "./../../environments/environment";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Component, OnInit } from "@angular/core";
import { PaymentService } from "../services/payment/payment.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  NgForm,
} from "@angular/forms";
import "rxjs/add/observable/of";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";
import { AccountsService } from "../services/settings-service/accounts/accounts.service";
import swal from "sweetalert2";

@Component({
  selector: "projects",
  templateUrl: "./payment-generator.component.html",
  styleUrls: [
    "../../assets/css/style.css",
    "../../assets/css/custom.css",
    "./payment-generator.component.css",
  ],
  providers: [PaymentService],
})
export class PaymentGeneratorComponent implements OnInit {
  // generator_type => Fixed Plan, Mortage Calculator
  // Fixed plan => current inputs
  // mortage calculator => current inputs + mortage calculator
  // interval select monthly 1 - quarterly 3 - semi annunal - 6 yearly - 12
  // contract_period_in_months text
  // in starting date label should be contract starting date
  // first_installment_date
  // show another table in case of mortage calculator after update

  methods: any = [];
  installments: any;
  arr: any;
  current_units_arr: any;
  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  // used for fixing select bug onchange
  separated: any;

  unit_details: any;
  unit_id: any;

  phases: any;
  today = new Date();
  showMoreDetails: boolean = false;

  new_paymentForm: any = {
    generator_type: "Fixed Plan",
    percentage: "",
    slots: 1,
    service_room_slots: 0,
    service_room_with_bathroom_slots: 0,
    type: "",
    unit_serial: "",
    generated_view: "Total",
    status: "",
    build_area: "",
    starting_date: "",
    finishing_type_id: "",
    phase_id: "",
    price: "",
    cash_price: "",
    maintenance_fees_date: "",
    garage_fees_date: "",
    down_payment_type: "percentage",
    interval: "3",
    first_installment_date: "",
    contract_period_in_months: "",
  };

  installment_mortage;
  mortage_raw;

  down_payment_arr = [];
  maintenance_arr = [];
  special_payment_arr = [];
  regular_payment_arr = [];
  maintenance_fees_arr = [];
  garage_fees_arr = [];

  installmentsDetails = {
    down_payment_installment_count: null,
    down_payment_installment_value: null,
    down_payment_installment_total_value: null,
    first_down_payment_installment_date: null,
    special_payment_installment_count: null,
    special_payment_installment_value: null,
    special_payment_installment_total_value: null,
    first_special_payment_installment_date: null,
    maintenance_installment_count: null,
    maintenance_installment_value: null,
    maintenance_installment_total_value: null,
    first_maintenance_installment_date: null,
    maintenance_fees_count: null,
    maintenance_fees_value: null,
    maintenance_fees_total_value: null,
    first_maintenance_fees_date: null,
    garage_fees_count: null,
    garage_fees_value: null,
    garage_fees_total_value: null,
    first_garage_fees_date: null,
    regular_installment_count: null,
    regular_installment_value: null,
    regular_installment_total_value: null,
    first_regular_installment_date: null,
  };
  special_payment = {
    special_payment_type: "percentage",
    special_payment_value: null,
    special_payment_count: null,
    special_payment_interval: "12",
    special_payment_date: null,
  };
  special_payments: any = [];
  canReserveUnit: boolean = false;
  panelOpenState: boolean;
  allowedRoles: string[] = [];
  isRoleAllowed: boolean;
  generating_pdf: boolean;

  constructor(
    private http: HttpClient,
    private paymentService: PaymentService,
    private accountService: AccountsService,
    private fb: FormBuilder,
    private slimLoadingBarService: SlimLoadingBarService,
    public errorHandlerService: ErrorHandlerService,
    private userService: UserServiceService,
    private projectService: ProjectsService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    const today = new Date();
    this.new_paymentForm.starting_date = today.toISOString().slice(0, 10);
    this.new_paymentForm.interval = "3";
    this.calculateFirstInstallmentDate();
  }

  ngOnInit() {
    this.checkUnitIdQueryParameter();
    this.getAllowedRoles();
  }

  getAllowedRoles() {
    this.accountService.getMortageControlsRoles().subscribe(
      (data: any) => {
        this.allowedRoles = data.allowedRoles;
        let role = this.userProfile.role;
        this.isRoleAllowed = this.allowedRoles.includes(role);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  reassignInstallmentsDetails() {
    this.installmentsDetails = {
      down_payment_installment_count: null,
      down_payment_installment_value: null,
      down_payment_installment_total_value: null,
      first_down_payment_installment_date: null,
      special_payment_installment_count: null,
      special_payment_installment_value: null,
      special_payment_installment_total_value: null,
      first_special_payment_installment_date: null,
      maintenance_installment_count: null,
      maintenance_installment_value: null,
      maintenance_installment_total_value: null,
      first_maintenance_installment_date: null,
      maintenance_fees_count: null,
      maintenance_fees_value: null,
      maintenance_fees_total_value: null,
      first_maintenance_fees_date: null,
      garage_fees_count: null,
      garage_fees_value: null,
      garage_fees_total_value: null,
      first_garage_fees_date: null,
      regular_installment_count: null,
      regular_installment_value: null,
      regular_installment_total_value: null,
      first_regular_installment_date: null,
    };
  }

  onFinishTypePriceChange(id) {
    this.unit_details.finishing_types.forEach((type) => {
      this.new_paymentForm.price = type.pivot.price;
      this.new_paymentForm.cash_price = type.pivot.cash_price;
    });
    this.methods = [];
    this.new_paymentForm.type = "";
    let payload: any = this.getPaymentTermsPaylod();
    console.log(payload);
    if (payload.project_id && payload.finishing_type_id) {
      this.installments = null;
      this.separated = null;
      this.getPaymentTerms(payload);
    }
  }

  changePaymentMethod(event) {
    if (this.new_paymentForm.type != "Down Town Port Said 20 perc DP") {
      this.new_paymentForm.down_payment = "total";
    }
    console.log(event);
    this.methods.forEach((element) => {
      if (element.id == event) {
        this.new_paymentForm.percentage = element.downpayment_percentage;
      }
    });
  }

  observableSource = (keyword: any): any => {
    const data = {
      unit_serial: keyword,
    };
    if (keyword) {
      this.slimLoadingBarService.start(() => {
        console.log("Loading complete");
      });
      return this.http
        .post(
          `${environment.api_base_url}units/search/available_by_serial`,
          JSON.stringify(data)
        )
        .map((res: any) => {
          console.log(res.length);
          this.current_units_arr = res;
          this.slimLoadingBarService.complete();
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arr = [];
            res.forEach((e) => {
              console.log(e);
              this.arr.push(e.serial + " (" + e.project.name + ")");
            });
            console.log(this.arr);
            return this.arr;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  onChangeNumberOfSlots() {
    if (this.new_paymentForm.slots == "0") {
      this.new_paymentForm.garage_fees_date = null;
    }
  }

  getPaymentTerms(payload) {
    this.userService.getProjectPaymentTerms(payload).subscribe(
      (res) => {
        const arr: any = res;
        this.methods = arr;
        if (this.new_paymentForm.generator_type === "Fixed Plan" && this.methods && this.methods.length > 0) {
          this.methods[0].extras.forEach((elem) => {
            if (elem.type_text == "Maintenance") {
              const today = new Date();
              today.setMonth(today.getMonth() + elem.interval);
              this.new_paymentForm.maintenance_fees_date = today
                .toISOString()
                .slice(0, 10);
            } else {
              if (this.new_paymentForm.slots !== "0") {
                const today = new Date();
                today.setMonth(today.getMonth() + elem.interval);
                this.new_paymentForm.garage_fees_date = today
                  .toISOString()
                  .slice(0, 10);
              }
            }
          });
        }
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  valueChanged(ev) {
    console.log(this.current_units_arr);
    this.current_units_arr.forEach((element) => {
      if (element.serial + " (" + element.project.name + ")" == ev) {
        this.new_paymentForm.unit_serial = element.serial;
        console.log("matched");
        console.log(element);
        this.unit_details = element;
        this.new_paymentForm.project_type = element.project.type;
        this.phases = element.project.phases;
        this.new_paymentForm.status = element.status;
        this.new_paymentForm.build_area = element.build_area;
        this.new_paymentForm.type = "";
        this.new_paymentForm.phase_id = element.phase_id;
        // this.getPaymentTerms(element.project.id);
        this.new_paymentForm.percentage = "";
      }
    });
  }

  onPhaseChange(id) {
    this.methods = [];
    this.new_paymentForm.type = "";
    let payload: any = this.getPaymentTermsPaylod();
    if (payload.project_id && payload.finishing_type_id) {
      this.getPaymentTerms(payload);
    }
  }

  getPaymentTermsPaylod() {
    let payload = {
      project_id: this.unit_details.project.id,
      phase_id: this.new_paymentForm.phase_id,
      finishing_type_id: this.new_paymentForm.finishing_type_id,
    };
    return payload;
  }

  pdf() {
    let url = `${environment.api_raw_base_url}installments/pdf/${this.unit_id}/${this.new_paymentForm.type}?generated_view=${this.new_paymentForm.generated_view}&slots=${this.new_paymentForm.slots}&service_room_slots=${this.new_paymentForm.service_room_slots}&service_room_with_bathroom_slots=${this.new_paymentForm.service_room_with_bathroom_slots}&finishing_type_id=${this.new_paymentForm.finishing_type_id}`;

    if (this.userProfile.role === "Admin" || this.userProfile.role == "CFO") {
      url += `&tot_amount_for_unit=${this.new_paymentForm.price}`;
    }
    url += `&starting_date=${this.new_paymentForm.starting_date}`;
    window.open(url);
  }

  excel() {
    let url = `${environment.api_raw_base_url}/installments/excel/${this.unit_id}/${this.new_paymentForm.type}?generated_view=${this.new_paymentForm.generated_view}&slots=${this.new_paymentForm.slots}&service_room_slots=${this.new_paymentForm.service_room_slots}&service_room_with_bathroom_slots=${this.new_paymentForm.service_room_with_bathroom_slots}&finishing_type_id=${this.new_paymentForm.finishing_type_id}`;

    if (this.userProfile.role === "Admin" || this.userProfile.role == "CFO") {
      url += `&tot_amount_for_unit=${this.new_paymentForm.price}`;
    }
    url += `&starting_date=${this.new_paymentForm.starting_date}`;
    window.open(url);
  }

  getInstallments(paymentForm: NgForm) {
    console.log(paymentForm.invalid);
    if (paymentForm.invalid) {
      this.showValidationErrors(paymentForm);
      return;
    }
    this.reassignInstallmentsDetails();
    this.separated = [];
    this.installments = [];
    this.maintenance_arr = [];
    this.down_payment_arr = [];
    this.special_payment_arr = [];
    this.regular_payment_arr = [];
    this.installment_mortage = [];
    this.showMoreDetails = false;

    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    // console.log(this.unit_details);
    let data;
    if (this.new_paymentForm.generator_type === "Fixed Plan") {
      data = {
        generator_type: this.new_paymentForm.generator_type,
        down_payment: this.new_paymentForm.percentage,
        slots: this.new_paymentForm.slots,
        service_room_slots: this.new_paymentForm.service_room_slots,
        service_room_with_bathroom_slots:
          this.new_paymentForm.service_room_with_bathroom_slots,
        type: this.new_paymentForm.type,
        unit_serial: this.unit_details.serial,
        generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        cash_price: this.new_paymentForm.cash_price,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id,
        maintenance_fees_date: this.new_paymentForm.maintenance_fees_date,
        garage_fees_date: this.new_paymentForm.garage_fees_date,
        unit_id: this.unit_details.id,
      };
    } else {
      data = {
        generator_type: this.new_paymentForm.generator_type,
        slots: this.new_paymentForm.slots,
        // service_room_slots: this.new_paymentForm.service_room_slots,
        // service_room_with_bathroom_slots:
        //   this.new_paymentForm.service_room_with_bathroom_slots,
        // type: this.new_paymentForm.type,
        unit_serial: this.new_paymentForm.unit_serial,
        // generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id,
        interval: Number(this.new_paymentForm.interval),
        contract_period_in_months:
          this.new_paymentForm.contract_period_in_months,
        first_installment_date: this.new_paymentForm.first_installment_date,
        cash_price: this.new_paymentForm.cash_price,
        maintenance_fees_date: this.new_paymentForm.maintenance_fees_date,
        garage_fees_date: this.new_paymentForm.garage_fees_date,
        down_payment_type: this.new_paymentForm.down_payment_type,
        down_payment:
          this.new_paymentForm.down_payment_type === "percentage"
            ? this.new_paymentForm.percentage
            : this.new_paymentForm.amount,
        unit_id: this.unit_details.id,
      };
      if (this.special_payments.length > 0) {
        data.special_payments = this.special_payments;
      }
    }
    this.paymentService.getInstallments(data).subscribe(
      (data) => {
        if (data.totalPlanArr) {
          data.totalPlanArr.forEach((item) => {
            if (item.is_down_payment) {
              this.down_payment_arr.push(item);
            } else if (item.is_special_payment) {
              this.special_payment_arr.push(item);
            } else if (
              item.is_extra_payment &&
              item.num === "Maintenance Fees"
            ) {
              this.maintenance_fees_arr.push(item);
            } else if (item.is_extra_payment && item.num === "Garage Fees") {
              this.garage_fees_arr.push(item);
            } else {
              this.regular_payment_arr.push(item);
            }
          });
          if (this.down_payment_arr.length > 0) {
            this.installmentsDetails.down_payment_installment_count =
              this.down_payment_arr.length;
            this.installmentsDetails.down_payment_installment_value =
              this.down_payment_arr[0].installment_value;
            this.installmentsDetails.down_payment_installment_total_value =
              this.down_payment_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
            this.installmentsDetails.first_down_payment_installment_date =
              this.down_payment_arr[0].installment_date;
          }
          if (this.special_payment_arr.length > 0) {
            this.installmentsDetails.special_payment_installment_count =
              this.special_payment_arr.length;
            this.installmentsDetails.special_payment_installment_value =
              this.special_payment_arr[0].installment_value;
            this.installmentsDetails.special_payment_installment_total_value =
              this.special_payment_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
            this.installmentsDetails.first_special_payment_installment_date =
              this.special_payment_arr[0].installment_date;
          }
          if (this.regular_payment_arr.length > 0) {
            this.installmentsDetails.regular_installment_count =
              this.regular_payment_arr.length;
            this.installmentsDetails.regular_installment_value =
              this.regular_payment_arr[0].installment_value;
            this.installmentsDetails.regular_installment_total_value =
              this.regular_payment_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
            this.installmentsDetails.first_regular_installment_date =
              this.regular_payment_arr[0].installment_date;
          }
          if (this.maintenance_fees_arr.length > 0) {
            this.installmentsDetails.maintenance_fees_count =
              this.maintenance_fees_arr.length;
            this.installmentsDetails.first_maintenance_fees_date =
              this.maintenance_fees_arr[0].installment_date;
            this.installmentsDetails.maintenance_fees_value =
              this.maintenance_fees_arr[0].installment_value;
            this.installmentsDetails.maintenance_fees_total_value =
              this.maintenance_fees_arr.reduce(
                (a, b) => a + b.installment_value,
                0
              );
          }
          if (this.garage_fees_arr.length > 0) {
            this.installmentsDetails.garage_fees_count =
              this.garage_fees_arr.length;
            this.installmentsDetails.first_garage_fees_date =
              this.garage_fees_arr[0].installment_date;
            this.installmentsDetails.garage_fees_value =
              this.garage_fees_arr[0].installment_value;
            this.installmentsDetails.garage_fees_total_value =
              this.garage_fees_arr.reduce((a, b) => a + b.installment_value, 0);
          }
        }
        if (data.main) {
          data.main.forEach((item) => {
            if (item.Installment.includes("Down Payment")) {
              this.down_payment_arr.push(item);
            } else if (item.Installment.includes("Maintenence")) {
              this.maintenance_arr.push(item);
            } else if (
              item.is_extra_payment &&
              item.num === "Maintenance Fees"
            ) {
              this.maintenance_arr.push(item);
            } else if (item.Installment.includes("Installment")) {
              this.regular_payment_arr.push(item);
            }
          });
          if (this.down_payment_arr.length > 0) {
            if (this.down_payment_arr[0].Amount.includes(",")) {
              this.down_payment_arr.forEach((item) => {
                item.Amount = item.Amount.replaceAll(",", "");
                item.Amount = Number(item.Amount);
              });
            }
            this.installmentsDetails.down_payment_installment_count =
              this.down_payment_arr.length;
            this.installmentsDetails.down_payment_installment_value =
              this.down_payment_arr[0].Amount;
            this.installmentsDetails.down_payment_installment_total_value =
              this.down_payment_arr.reduce((a, b) => a + b.Amount, 0);
            this.installmentsDetails.first_down_payment_installment_date =
              this.down_payment_arr[0].Date;
          }
          if (this.regular_payment_arr.length > 0) {
            if (this.regular_payment_arr[0].Amount.includes(",")) {
              this.regular_payment_arr.forEach((item) => {
                item.Amount = item.Amount.replaceAll(",", "");
                item.Amount = Number(item.Amount);
              });
            }
            this.installmentsDetails.regular_installment_count =
              this.regular_payment_arr.length;
            this.installmentsDetails.regular_installment_value =
              this.regular_payment_arr[0].Amount;
            this.installmentsDetails.regular_installment_total_value =
              this.regular_payment_arr.reduce((a, b) => a + b.Amount, 0);
            this.installmentsDetails.first_regular_installment_date =
              this.regular_payment_arr[0].Date;
          }
          if (this.maintenance_arr.length > 0) {
            if (this.maintenance_arr[0].Amount.includes(",")) {
              this.maintenance_arr.forEach((item) => {
                item.Amount = item.Amount.replaceAll(",", "");
                item.Amount = Number(item.Amount);
              });
            }
            this.installmentsDetails.maintenance_installment_count =
              this.maintenance_arr.length;
            this.installmentsDetails.first_maintenance_installment_date =
              this.maintenance_arr[0].Date;
            this.installmentsDetails.maintenance_installment_value =
              this.maintenance_arr[0].Amount;
            this.installmentsDetails.maintenance_installment_total_value =
              this.maintenance_arr.reduce((a, b) => a + b.Amount, 0);
          }
        }
        if (this.new_paymentForm.generator_type === "Fixed Plan") {
          this.installments = data.main;
          this.separated = data.finishing;
        } else {
          this.mortage_raw = data;
          this.installment_mortage = data.totalPlanArr;
          console.log(this.installment_mortage);
        }
        this.slimLoadingBarService.complete();
        this.canReserveUnit = true;
        // this.datatableHandle();
        // this.show =true;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  exportWithMortageCalculator(fileType: string) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    let data;
    if (this.new_paymentForm.generator_type === "Fixed Plan") {
      data = {
        generator_type: this.new_paymentForm.generator_type,
        down_payment: this.new_paymentForm.percentage,
        slots: this.new_paymentForm.slots,
        service_room_slots: this.new_paymentForm.service_room_slots,
        service_room_with_bathroom_slots:
          this.new_paymentForm.service_room_with_bathroom_slots,
        type: this.new_paymentForm.type,
        unit_serial: this.new_paymentForm.unit_serial,
        generated_view: this.new_paymentForm.generated_view,
        price: this.new_paymentForm.price,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id,
        unit_id: this.unit_id,
      };
    } else {
      data = {
        generator_type: this.new_paymentForm.generator_type,
        unit_serial: this.new_paymentForm.unit_serial,
        unit_id: this.unit_id,
        price: this.new_paymentForm.price,
        starting_date: this.new_paymentForm.starting_date,
        finishing_type_id: this.new_paymentForm.finishing_type_id,
        interval: Number(this.new_paymentForm.interval),
        contract_period_in_months:
          this.new_paymentForm.contract_period_in_months,
        first_installment_date: this.new_paymentForm.first_installment_date,
        down_payment_type: this.new_paymentForm.down_payment_type,
        down_payment:
          this.new_paymentForm.down_payment_type === "percentage"
            ? this.new_paymentForm.percentage
            : this.new_paymentForm.amount,
      };
      if (this.special_payments.length > 0) {
        data.special_payments = this.special_payments;
      }
    }
    data.export_file = fileType;
    console.log(data);
    this.paymentService.getInstallments(data).subscribe(
      (data) => {
        window.open(data.url, "_blank");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  getUnitDetails(unit_id) {
    this.projectService.getUnitDetails(unit_id).subscribe(
      (data) => {
        console.log(data);
        this.unit_details = data;
        this.fillTheForm(data);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  checkUnitIdQueryParameter() {
    this.route.queryParams
      .filter((params) => params.unit_id)
      .subscribe((params) => {
        console.log(params);
        this.unit_id = params.unit_id;
        this.getUnitDetails(params.unit_id);
      });
  }

  fillTheForm(unit_details) {
    this.new_paymentForm.unit_serial = unit_details.serial;
    this.new_paymentForm.unit_id = unit_details.id;
    this.new_paymentForm.project_type = unit_details.project.type;
    this.new_paymentForm.status = unit_details.status;
    this.new_paymentForm.build_area = unit_details.build_area;
    this.new_paymentForm.type = "";
    this.phases = unit_details.project.phases;
    this.unit_details = unit_details;
    // this.getPaymentTerms(unit_details.project.id);
    this.new_paymentForm.percentage = "";
    this.new_paymentForm.phase_id = unit_details.phase_id;
    
    // Automatically set maintenance fees date and garage fees date to one year before delivery date
    if (unit_details.delivery_date) {
      const deliveryDate = new Date(unit_details.delivery_date);
      const oneYearBefore = new Date(deliveryDate);
      oneYearBefore.setFullYear(deliveryDate.getFullYear() - 1);
      
      // Format date as YYYY-MM-DD for input fields
      const formattedDate = oneYearBefore.toISOString().slice(0, 10);
      
      this.new_paymentForm.maintenance_fees_date = formattedDate;
      this.new_paymentForm.garage_fees_date = formattedDate;
    }
  }

  onGeneratorTypeChange(event) {
    console.log(event);
    this.new_paymentForm.finishing_type_id &&
      this.onFinishTypePriceChange(this.new_paymentForm.finishing_type_id);
  }

  onIntervalChange(event) {
    console.log('Interval changed to:', event);
    this.calculateFirstInstallmentDate();
  }

  calculateFirstInstallmentDate() {
    if (!this.new_paymentForm.interval) {
      return;
    }

    const today = new Date();
    let firstInstallmentDate = new Date(today);

    switch (this.new_paymentForm.interval) {
      case '1': // Monthly
        firstInstallmentDate.setMonth(today.getMonth() + 1);
        break;
      case '3': // Quarterly
        firstInstallmentDate.setMonth(today.getMonth() + 3);
        break;
      case '6': // Semi-Annual
        firstInstallmentDate.setMonth(today.getMonth() + 6);
        break;
      case '12': // Annual
        firstInstallmentDate.setFullYear(today.getFullYear() + 1);
        break;
      default:
        // Default to 3 months if invalid interval
        firstInstallmentDate.setMonth(today.getMonth() + 3);
        break;
    }

    // Ensure the date is not in the past
    if (firstInstallmentDate <= today) {
      firstInstallmentDate = new Date(today);
      switch (this.new_paymentForm.interval) {
        case '1':
          firstInstallmentDate.setMonth(today.getMonth() + 1);
          break;
        case '3':
          firstInstallmentDate.setMonth(today.getMonth() + 3);
          break;
        case '6':
          firstInstallmentDate.setMonth(today.getMonth() + 6);
          break;
        case '12':
          firstInstallmentDate.setFullYear(today.getFullYear() + 1);
          break;
      }
    }

    // Format date as YYYY-MM-DD for input field
    this.new_paymentForm.first_installment_date = firstInstallmentDate.toISOString().slice(0, 10);
  }

  showValidationErrors(paymentForm: NgForm) {
    const missingFields: string[] = [];
    
    // Check each form control for validation errors
    Object.keys(paymentForm.controls).forEach(controlName => {
      const control = paymentForm.controls[controlName];
      
      if (control.invalid && control.errors) {
        let fieldName = this.getFieldDisplayName(controlName);
        
        // Check specific validation errors
        if (control.errors['required']) {
          missingFields.push(`${fieldName} is required`);
        } else if (control.errors['minlength']) {
          missingFields.push(`${fieldName} must be at least ${control.errors['minlength'].requiredLength} characters`);
        } else if (control.errors['maxlength']) {
          missingFields.push(`${fieldName} must not exceed ${control.errors['maxlength'].requiredLength} characters`);
        } else if (control.errors['pattern']) {
          missingFields.push(`${fieldName} format is invalid`);
        } else if (control.errors['email']) {
          missingFields.push(`${fieldName} must be a valid email address`);
        } else {
          missingFields.push(`${fieldName} is invalid`);
        }
      }
    });

    if (missingFields.length > 0) {
      const errorMessage = `Please fix the following validation errors:\n\n${missingFields.join('\n')}`;
      
      swal('Validation Errors', errorMessage, 'error');
    }
  }

  getFieldDisplayName(controlName: string): string {
    const fieldNames: { [key: string]: string } = {
      'generator_type': 'Generate Type',
      'unit_serial': 'Unit Serial',
      'unit_id': 'Unit ID',
      'finishing_type_id': 'Finish Type',
      'type': 'Payment Method Type',
      'generated_view': 'Generated View',
      'price': 'Unit List Price',
      'cash_price': 'Unit Cash Price',
      'status': 'Unit Status',
      'build_area': 'Unit Area',
      'contract_period_in_months': 'Contract Period In Months',
      'percentage': 'Down Payment %',
      'down_payment_type': 'Down Payment Type',
      'amount': 'Down Payment Amount',
      'slots': 'Number of parking Slots',
      'service_room_slots': 'Number of Service Room Slots',
      'service_room_with_bathroom_slots': 'Number of Service Room With Bathroom Slots',
      'starting_date': 'Starting Date',
      'first_installment_date': 'First Installment Date',
      'interval': 'Interval',
      'maintenance_fees_date': 'Maintenance Fees Date',
      'garage_fees_date': 'Parking Fees Date'
    };

    return fieldNames[controlName] || controlName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }

  addSpecialPayment() {
    this.special_payments.push({ ...this.special_payment });
    this.special_payment = {
      special_payment_type: "percentage",
      special_payment_value: null,
      special_payment_count: null,
      special_payment_interval: "12",
      special_payment_date: null,
    };
    console.log(this.special_payments);
  }

  deleteSpecialPayment(index) {
    this.special_payments.splice(index, 1);
  }

  reserve() {
    const special_payment_list = JSON.stringify(this.special_payments);
    const is_special_payment = this.special_payments.length > 0 ? true : false;
    const reserveData = {
      generator_type: this.new_paymentForm.generator_type,
      percentage: this.new_paymentForm.percentage,
      slots: this.new_paymentForm.slots,
      service_room_slots: this.new_paymentForm.service_room_slots,
      service_room_with_bathroom_slots:
        this.new_paymentForm.service_room_with_bathroom_slots,
      type: this.new_paymentForm.type,
      generated_view: this.new_paymentForm.generated_view,
      status: this.new_paymentForm.status,
      build_area: this.new_paymentForm.build_area,
      contract_date: this.new_paymentForm.starting_date,
      finishing_type_id: this.new_paymentForm.finishing_type_id,
      phase_id: this.new_paymentForm.phase_id,
      down_payment_type: this.new_paymentForm.down_payment_type,
      first_installment_date: this.new_paymentForm.first_installment_date,
      contract_period_in_months: this.new_paymentForm.contract_period_in_months,
      cash_price: this.new_paymentForm.cash_price,
      maintenance_fees_date: this.new_paymentForm.maintenance_fees_date,
      garage_fees_date: this.new_paymentForm.garage_fees_date,
      interval: this.new_paymentForm.interval,
      is_special_payment: is_special_payment,
    };
    localStorage.setItem("special_payments", special_payment_list);
    console.log(special_payment_list);
    if (this.mortage_raw.periodMeterPrice) {
      reserveData["meter_price"] = this.mortage_raw.periodMeterPrice;
    }
    this.router.navigate([`pages/reservations/add/${this.unit_id}`], {
      queryParams: reserveData,
    });
  }

  printPdf() {
    this.generating_pdf = true;
    this.slimLoadingBarService.start();
    this.paymentService.getOfferPdf(this.new_paymentForm).subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.generating_pdf = false;
        window.open(`https://${res.url}`);
      },
      (err) => {
        this.slimLoadingBarService.reset();
        this.errorHandlerService.handleErorr(err);
        this.generating_pdf = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/payment-generator/payment-generator.component.ts